import React, { useState } from 'react';
import {
  Autocomplete,
  TextField,
  Checkbox,
  Paper,
  Typography,
  Box,
  IconButton,
  Chip,
  Button,
  Slider,
  FormControl,
  InputLabel,
  MenuItem,
  Select
} from '@mui/material';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PersonIcon from '@mui/icons-material/Person';
import SchoolIcon from '@mui/icons-material/School';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { locationsOptions } from '../utilities/constants';

const Filters = ({ statesOptions, industriesOptions, selectedFilters, setSelectedFilters }) => {
  const [collapsedSections, setCollapsedSections] = useState({
    identity: false,
    education: false,
    location: false,
    money: false
  });

  const updateFilter = (key, newValue) => {
    setSelectedFilters((prev) => ({ ...prev, [key]: newValue }));
  };

  const toggleCollapse = (key) => {
    setCollapsedSections((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const clearAllFilters = () => {
    setSelectedFilters({
      education: [],
      location: [],
      industry: [],
      compellingEvents: [],
      gender: [],
    });
  };

  const handleFilterChange = (key, value) => {
    setSelectedFilters((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const moneyInMotionEvents = [
    "Inheritance",
    "Promotion",
    "Job Change",
    "Marriage",
    "Divorce",
    "Recently Moved",
    "Childbirth",
    "Reached Retirement Age",
    "Sale of Business",
    "Sale of stock",
    "Recent Fundraising Round",
    "Recent Donation"
  ];

  return (
    <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="h6" fontWeight="bold">
          Filters
        </Typography>
        <Button onClick={clearAllFilters} size="small">CLEAR ALL</Button>
      </Box>

      <Box>
        <Typography variant="subtitle1" fontWeight="bold" sx={{ display: 'flex', alignItems: 'center' }}>
          <EmojiEventsIcon sx={{ mr: 1 }} />
          Money in Motion
          <IconButton onClick={() => toggleCollapse('money')}>
            {collapsedSections.money ? <ExpandMoreIcon /> : <ExpandLessIcon />}
          </IconButton>
        </Typography>
        {!collapsedSections.money && (
          <Paper elevation={2} sx={{ padding: 2 }}>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
              {moneyInMotionEvents.map((label) => (
                <Chip
                  key={label}
                  icon={<EmojiEventsIcon fontSize="small" />}
                  label={label}
                  color={selectedFilters.compellingEvents?.includes(label) ? 'primary' : 'default'}
                  onClick={() => {
                    const newSelection = selectedFilters.compellingEvents?.includes(label)
                      ? selectedFilters.compellingEvents.filter((e) => e !== label)
                      : [...(selectedFilters.compellingEvents || []), label];
                    updateFilter('compellingEvents', newSelection);
                  }}
                />
              ))}
            </Box>
          </Paper>
        )}
      </Box>

      {/* Location & Region */}
      <Box>
        <Typography variant="subtitle1" fontWeight="bold" sx={{ display: 'flex', alignItems: 'center' }}>
          <LocationOnIcon sx={{ mr: 1 }} />
          Location & Region
          <IconButton onClick={() => toggleCollapse('location')}>
            {collapsedSections.location ? <ExpandMoreIcon /> : <ExpandLessIcon />}
          </IconButton>
        </Typography>
        {!collapsedSections.location && (
          <Paper elevation={2} sx={{ padding: 2 }}>
            <Autocomplete
            multiple
            options={locationsOptions}
            getOptionLabel={(option) => option.name} // Display the full state name
            value={selectedFilters?.location?.map((abbreviation) =>
                locationsOptions.find((state) => state.abbreviation === abbreviation) || { name: '', abbreviation: '' }
            )} // Map abbreviations to full state objects
            onChange={(_, newValue) => {
                const abbreviations = newValue.map((state) => state.abbreviation); // Store only the abbreviations
                handleFilterChange('location', abbreviations);
            }}
            renderInput={(params) => <TextField {...params} label="Locations (US States)" variant="outlined" />}
            />
          </Paper>
        )}
      </Box>

      {/* Identity & Demographics */}
      <Box>
        <Typography variant="subtitle1" fontWeight="bold" sx={{ display: 'flex', alignItems: 'center' }}>
          <PersonIcon sx={{ mr: 1 }} />
          Identity & Demographics
          <IconButton onClick={() => toggleCollapse('identity')}>
            {collapsedSections.identity ? <ExpandMoreIcon /> : <ExpandLessIcon />}
          </IconButton>
        </Typography>
        {!collapsedSections.identity && (
          <>
            {[
              { label: 'Gender', key: 'gender', options: ["Male", "Female"] },
              // { label: 'Age range', key: 'ageRange', options: ["18-25", "25-30", "30-35", "35-40", "40-45", "45-50", "55-60", "60-65", "65+"] },
              // { label: 'Net worth', key: 'netWorthRange', options: ["< $100,000", "$100,000 - $250,000", "$250,000 - $500,000", "$500,000 - $1,000,000", "$1,000,000 - $2,000,000", "$2,000,000 - $5,000,000", "$5,000,000 - $15,000,000", "$15,000,000+"] },
            ].map(({ label, key, options }) => (
              <Paper key={key} elevation={2} sx={{ padding: 2 }}>
                <Autocomplete
                  multiple
                  disableCloseOnSelect
                  options={options}
                  value={selectedFilters[key] || []}
                  onChange={(_, newValue) => updateFilter(key, newValue)}
                  renderOption={(props, option) => (
                    <Box component="li" {...props}>
                      <Checkbox checked={selectedFilters[key]?.includes(option)} sx={{ padding: 0.5, mr: 1 }} />
                      {option}
                    </Box>
                  )}
                  renderInput={(params) => <TextField {...params} variant="outlined" size="small" placeholder={`Select ${label.toLowerCase()}`} />}
                />
              </Paper>
            ))}
            {/* Age Range Slider */}
{/* Age Range Slider */}
<Paper elevation={2} sx={{ padding: 2 }}>
  <Typography gutterBottom>Age Range</Typography>
  <Slider
    value={selectedFilters.ageRange || [0, 100]}
    onChange={(_, newValue) => updateFilter('ageRange', newValue)}
    valueLabelDisplay="auto"
    min={0} // Allow dragging below the normal minimum
    max={100} // Allow dragging above the normal maximum
    marks={[
      { value: 0, label: 'No min' }, // Special label for unbounded minimum
      { value: 20, label: '20' },
      { value: 40, label: '40' },
      { value: 60, label: '60' },
      { value: 80, label: '80' },
      { value: 100, label: 'No max' }, // Special label for unbounded maximum
    ]}
  />
</Paper>
<Paper elevation={2} sx={{ padding: 2 }}>
  <Typography gutterBottom>Net Worth</Typography>
  <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
    {/* Minimum Net Worth Dropdown */}
    <FormControl variant="outlined" size="small">
      <InputLabel>Min</InputLabel>
      <Select
        value={selectedFilters.netWorthRange?.[0] ?? ''}
        onChange={(e) => {
          const minValue = parseInt(e.target.value, 10) || 0;
          updateFilter('netWorthRange', [minValue, selectedFilters.netWorthRange?.[1] || 20000000]);
        }}
        label="Min"
      >
        <MenuItem value={0}>No Min</MenuItem>
        <MenuItem value={50000}>$50K</MenuItem>
        <MenuItem value={100000}>$100K</MenuItem>
        <MenuItem value={250000}>$250K</MenuItem>
        <MenuItem value={500000}>$500K</MenuItem>
        <MenuItem value={1000000}>$1M</MenuItem>
        <MenuItem value={2000000}>$2M</MenuItem>
        <MenuItem value={5000000}>$5M</MenuItem>
        <MenuItem value={10000000}>$10M</MenuItem>
        <MenuItem value={15000000}>$15M</MenuItem>
      </Select>
    </FormControl>

    {/* Maximum Net Worth Dropdown */}
    <FormControl variant="outlined" size="small">
      <InputLabel>Max</InputLabel>
      <Select
        value={selectedFilters.netWorthRange?.[1] || ''}
        onChange={(e) => {
          const maxValue = parseInt(e.target.value, 10) || 0;
          updateFilter('netWorthRange', [selectedFilters.netWorthRange?.[0] || 0, maxValue]);
        }}
        label="Max"
      >
        <MenuItem value={20000000}>No Max</MenuItem>
        <MenuItem value={50000}>$50K</MenuItem>
        <MenuItem value={100000}>$100K</MenuItem>
        <MenuItem value={250000}>$250K</MenuItem>
        <MenuItem value={500000}>$500K</MenuItem>
        <MenuItem value={1000000}>$1M</MenuItem>
        <MenuItem value={2000000}>$2M</MenuItem>
        <MenuItem value={5000000}>$5M</MenuItem>
        <MenuItem value={10000000}>$10M</MenuItem>
        <MenuItem value={15000000}>$15M</MenuItem>
      </Select>
    </FormControl>
  </Box>
</Paper>
          </>
        )}
      </Box>

      {/* Education & Professional */}
      <Box>
        <Typography variant="subtitle1" fontWeight="bold" sx={{ display: 'flex', alignItems: 'center' }}>
          <SchoolIcon sx={{ mr: 1 }} />
          Education & Professional Background
          <IconButton onClick={() => toggleCollapse('education')}>
            {collapsedSections.education ? <ExpandMoreIcon /> : <ExpandLessIcon />}
          </IconButton>
        </Typography>
        {!collapsedSections.education && (
          <>
            {[
              { label: 'Industry', key: 'industry', options: industriesOptions },
            ].map(({ label, key, options }) => (
              <Paper key={key} elevation={2} sx={{ padding: 2 }}>
                <Autocomplete
                  multiple
                  disableCloseOnSelect
                  options={options}
                  value={selectedFilters[key] || []}
                  onChange={(_, newValue) => updateFilter(key, newValue)}
                  renderOption={(props, option) => (
                    <Box component="li" {...props}>
                      <Checkbox checked={selectedFilters[key]?.includes(option)} sx={{ padding: 0.5, mr: 1 }} />
                      {option}
                    </Box>
                  )}
                  renderInput={(params) => <TextField {...params} variant="outlined" size="small" placeholder={`Select ${label.toLowerCase()}`} />}
                />
              </Paper>
            ))}
          </>
        )}
      </Box>
    </Box>
  );
};

export default Filters;
